import React, { useContext } from 'react';
import { PiDotsThreeOutlineVertical } from 'react-icons/pi';
import { AgentCardStyled, ReponseMenu, MenuBtn, StyleItem } from './AgentCard.styles';
import ModalContainer from '../ModalContainer';
import DeleteAgentModal from '../DeleteAgentModal';
import CreatAgentModal from '../CreatAgentModal';
import cardIcon from '../../assets/feeda-icon.svg';
import UploadFileModal from '../UploadFileModal';
import sessionsService from '../../services/sessionsServices';
import { TemporaryChatContext } from '../../Context/temporaryChatContext';
import { useNavigate } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';

const AgentCard = ({
  agentCardsData,
  setSuccessModal,
  removeDelete = false,
  removeDuplicate = false,
  aiAgents = true,
  filterName,
}) => {
  const { setChatmessages, updateAgent, setSessionAgent } = useContext(TemporaryChatContext);

  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));

  const navigate = useNavigate();
  const chatWithAgent = async agentObj => {
    updateAgent(agentObj);
    await setSessionAgent(agentObj);
    setChatmessages([]);
    const sessionRes = await sessionsService.createSession({
      user_id: user?.data?.ID,
      platform_id: 'feedalabs',
      agent_id: agentObj?.value,
      project_id: 'test',
    });
    navigate(`/chat/${sessionRes?.session_id}`);
  };

  return (
    <>
      {agentCardsData
        ?.filter(card => {
          if (!filterName) return true;
          return card.agent_name.toLowerCase().includes(filterName.toLowerCase());
        })
        ?.map(card => (
          <AgentCardStyled key={card.id}>
            <div className="card-header">
              <div className="img-box">
                <img src={card?.icon ?? cardIcon} alt="img" />
              </div>
              <span className="tag">official</span>
              <ReponseMenu
                menuButton={
                  <MenuBtn>
                    <PiDotsThreeOutlineVertical size="22" />
                  </MenuBtn>
                }>
                {/* <ModalContainer
                width="700"
                title="Manage Share Settings"
                content={({ onClose }) => <ShareAgentModal onClose={onClose} />}
                btnComponent={({ onClick }) => (
                  <StyleItem onClick={onClick}>
                    <div className="text">Share Agent</div>
                  </StyleItem>
                )}
              /> */}
                {removeDelete !== false && (
                  <ModalContainer
                    width="600"
                    title="Confirm Agent Deletion"
                    content={({ onClose }) => <DeleteAgentModal onClose={onClose} _id={card?.id} />}
                    btnComponent={({ onClick }) => (
                      <StyleItem onClick={onClick}>
                        <div className="text" style={{ color: 'var(--danger)' }}>
                          Delete Agent
                        </div>
                      </StyleItem>
                    )}
                  />
                )}
                {removeDelete !== false && (
                  <StyleItem onClick={() => navigate(`/edit-agent/${card?.id}`)}>
                    <div className="text">Edit Agent</div>
                  </StyleItem>
                  // <ModalContainer
                  //   width="1000"
                  //   title="Edit Agent"
                  //   content={({ onClose }) => <CreatAgentModal onClose={onClose} isEdit={card} />}
                  //   btnComponent={({ onClick }) => (
                  //     <StyleItem onClick={onClick}>
                  //       <div className="text">Edit Agent</div>
                  //     </StyleItem>
                  //     )}
                  //     />
                )}

                {removeDuplicate === false && (
                  <ModalContainer
                    width="1000"
                    title="Create Agent"
                    content={({ onClose }) => (
                      <CreatAgentModal onClose={onClose} isEdit={card} isDuplicate setSuccessModal={setSuccessModal} />
                    )}
                    btnComponent={({ onClick }) => (
                      <StyleItem onClick={onClick}>
                        <div className="text">Duplicate Agent</div>
                      </StyleItem>
                    )}
                  />
                )}

                <StyleItem
                  onClick={() =>
                    chatWithAgent({
                      label: card?.agent_name,
                      value: card?.id,
                      icon: card?.icon,
                    })
                  }>
                  <div className="text">Chat</div>
                </StyleItem>
                {removeDelete !== false && (
                  <ModalContainer
                    noHead
                    width="1150"
                    btnComponent={({ onClick }) => (
                      <StyleItem onClick={onClick}>
                        <div className="text">Attach documents</div>
                      </StyleItem>
                    )}
                    content={({ onClose }) => <UploadFileModal onClose={onClose} seprateUpdateID={card?.id} />}
                  />
                )}
              </ReponseMenu>
            </div>
            <div className="text-box">
              <strong className="title">{card.agent_name}</strong>
              <p>{card.description}</p>
            </div>
            {aiAgents && (
              <div className="card-footer">
                <div className="name">{card.creatorInitial}</div>
                <span className="created">Created by Feeda</span>
                {/* <span className="created">Created by {card.createdBy}</span> */}
              </div>
            )}
          </AgentCardStyled>
        ))}
    </>
  );
};

export default AgentCard;
